import getHelper from '../../../services/getHelper';
import { ExerciseSession, ExerciseSessionAnswers } from '../types';
import type { RequestExecute } from '../../../../api';

class ExerciseSessionHelper extends getHelper<ExerciseSession>('/exercise-sessions/:id') {
  /**
   * @desc Submit the exerise session answers
   * @return {RequestExecute}
   * @example
   * const response = await myClient.helpers.assessment.exerciseSession.submit()
   */
  submit(
    exerciseSessionid: number,
    exerciseSessionAnswers: ExerciseSessionAnswers
  ): RequestExecute<ExerciseSession> {
    const request = this.create(exerciseSessionAnswers, false);

    request.url += `/submit`;
    request.setRouteParam('id', `${exerciseSessionid}`);

    return request.execute();
  }
}

export default ExerciseSessionHelper;
